module.exports = __webpack_public_path__ + "static/media/view5.f50071f6.jpg";